import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Menu } from "@mui/icons-material";
import Navbar from "../../../components/@extended/nav-bar/Navbar";
import useBreakpoint from "../../../hooks/useBreakpoint";

const Navigation = () => {
  const [isSticky, setIsSticky] = useState(false);

  const breakpoint = useBreakpoint();
  const offsetvalue = breakpoint === "small" ? 25 : 150;

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > offsetvalue) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return <Navbar isSticky={isSticky} />;
};

export default Navigation;
